// extracted by mini-css-extract-plugin
module.exports = {"siteFooterContainer":"footer_siteFooterContainer__rDsqn","StaticPageFooter":"footer_StaticPageFooter__jvj9Z"};